import React, {useEffect, useState, useRef, useCallback} from 'react';
import "./PlannogrammAddTasckStyle.scss";
import {decodeTokens, FetchElements, GetCookie, updateRefreshToken} from "../../../utils/js/request";
import {MEDIA, PLANNOGRAMM} from "../../../utils/js/Const";
import ButtonHint from "../../../components/Buttons/buttonHint/ButtonHint";
import ButtonBack from "../../../components/Buttons/buttonBack/ButtonBack";
import {useNavigate} from "react-router-dom";
import AddPhotoSVG from "../../Hint/HintContainer/img/Vector.svg";
import {HandySvg} from "handy-svg";
import closeSVG from "../../Hint/HintContainer/AddImg/img/close-X.svg";
import trashSVG from "../PlannogrammAddTasck/img/trash.svg";
import {v4 as uuidv4} from 'uuid';
import CustomAlert from "../../../components/CustomAlert/CustomAlert";
import useFileUploader from "../../../utils/js/PhotoUploader";
import CustomSearch4 from "../../../components/CustomSearch2/CustomSearch4";

function PlannogrammAddTasck({ dataTasck, onClose }) {
    const [uploadedPhotoIds, setUploadedPhotoIds] = useState([]);

    const handleUploadComplete = useCallback((fileId, serverId) => {
        setUploadedPhotoIds(prev => {
            const newIds = [...prev, serverId];
            return newIds;
        });
    }, []);

    const {
        files: uploadedPhotos,
        progress,
        statuses,
        addFiles,
        removeFile: deletePhoto,
        retryUpload,
        isUploading,
        hasPendingUploads,
        initializeExistingFiles,
    } = useFileUploader({
        compress: false,
        onUploadComplete: handleUploadComplete,
        onUploadError: (fileId, error) => {
            console.error(`Ошибка загрузки файла ${fileId}:`, error);
            handleOpenAlert("Ошибка", `${error}`, "")
        },
    });

    let periodDays = [
        {id:1, name: "Каждый день", value: 1},
        {id:7, name: "Раз в неделю", value: 7},
        {id:14, name: "Раз в две недели", value: 14},
        {id:30, name: "Раз в месяц", value: 30},
        {id:90, name: "Раз в в три месяца", value: 90},
    ];

    let navigate = useNavigate();

    function purposeId() {
        return uuidv4();
    }

    const [accessToken, setAccessToken] = useState(GetCookie("access_token"));

    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) {
                const newToken = await updateRefreshToken(setAccessToken,null,()=>{navigate("/")});
                if (newToken) {
                    decodeTokens();
                }
            } else {
                decodeTokens();
            }
        };
        fetchData();
    }, [accessToken, navigate]);

    const [isLoading, setIsLoading] = useState(false);

    const [priorities, setPriorities] = useState([]);
    const [kust, setKust] = useState([]);
    const [categories, setCategories] = useState([]);
    const [formats, setFormats] = useState([]);
    const [shops, setShops] = useState([]);

    const [selectedName, setSelectedName] = useState(dataTasck?.name || "");
    const [selectedPriorities, setSelectedPriorities] = useState(dataTasck?.priority?.name || "");
    const [selectedDescription, setSelectedDescription] = useState(dataTasck?.about || "");
    const [selectedKust, setSelectedKust] = useState("");
    const [selectedCategories, setSelectedCategories] = useState("");
    const [selectedFormats, setSelectedFormats] = useState("");
    const [selectedShops, setSelectedShops] = useState([]);
    const [selectedDateStart, setSelectedDateStart] = useState(formatDateForInput(dataTasck?.datetime_begin) || "");
    const [radioButton, setRadioButton] = useState(dataTasck?.for_close_need_photo || false);
    const [selectedDataEnd, setSelectedDataEnd] = useState(formatDateForInput(dataTasck?.datetime_end) || "");
    const [selectedComment, setSelectedComment] = useState(dataTasck?.comment || "");
    const [selectedPeriodDays, setSelectedPeriodDays] = useState("");

    const [selectKust_id, setSelectKust_id] = useState();
    const [selectFormat_id, setSelectFormat_id] = useState();
    const [selectCategories_id, setSelectCategories_id] = useState();
    const [selectedPriority_id, setSelectedPriority_id] = useState(dataTasck?.priority?.id || "");
    const [selectedShop_id, setSelectedShop_id] = useState([]);
    const [selectedPeriodDays_id, setSelectedPeriodDays_id] = useState(dataTasck?.period_days);

    const prevDataRef = useRef();

    const selectedShopIdsRef = useRef([]);

    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertStatusCod, setAlertStatusCod] = useState('');

    const handleOpenAlert = (title, message, statusCod) => {
        setAlertTitle(title);
        setAlertMessage(message);
        setAlertStatusCod(statusCod);
        setIsOpenAlert(true);
    };

    const handleCloseAlert = () => {
        setIsOpenAlert(false);
    };

    useEffect(() => {
        selectedShopIdsRef.current = selectedShop_id;
    }, [selectedShop_id]);

    const addShop = useCallback((shopId, shopName) => {
        if (!selectedShopIdsRef.current.includes(shopId)) {
            setSelectedShops(prev => [...prev, shopName]);
            setSelectedShop_id(prev => [...prev, shopId]);
        }
    }, []);

    const addMultipleShops = useCallback((shopList) => {
        if (!Array.isArray(shopList)) return;

        const newShops = [];
        const newShopIds = [];

        shopList.forEach(shop => {
            if (shop && shop.id && shop.name) {
                if (!selectedShopIdsRef.current.includes(shop.id)) {
                    newShops.push(shop.name);
                    newShopIds.push(shop.id);
                }
            }
        });

        if (newShops.length > 0) {
            setSelectedShops(prev => [...prev, ...newShops]);
            setSelectedShop_id(prev => [...prev, ...newShopIds]);
        }
    }, []);

    const removeShop = useCallback((index) => {
        setSelectedShops(prev => prev.filter((_, i) => i !== index));
        setSelectedShop_id(prev => prev.filter((_, i) => i !== index));
    }, []);

    const handleShopSelect = useCallback((shop) => {
        if (shop && shop.id && shop.name) {
            addShop(shop.id, shop.name);
        }
    }, [addShop]);

    const handleKustSelect = useCallback((kustItem) => {
        if (kustItem && kustItem.id) {
            setSelectedKust(kustItem.name);
            setSelectKust_id(kustItem.id);

            if (kustItem.id) {
                FetchElements(`${PLANNOGRAMM}/api/v1/shops?kust_id=${kustItem.id}`, "GET",
                    (data) => {
                        if (Array.isArray(data)) {
                            addMultipleShops(data);
                        }
                    },
                    navigate, 2, () => navigate("/"), handleOpenAlert
                );
            }
        }
    }, [addMultipleShops, navigate]);

    const handleFormatSelect = useCallback((formatItem) => {
        if (formatItem && formatItem.id) {
            setSelectedFormats(formatItem.name);
            setSelectFormat_id(formatItem.id);

            if (formatItem.id) {
                FetchElements(`${PLANNOGRAMM}/api/v1/shops?format_id=${formatItem.id}`, "GET",
                    (data) => {
                        if (Array.isArray(data)) {
                            addMultipleShops(data);
                        }
                    },
                    navigate, 2, () => navigate("/"), handleOpenAlert
                );
            }
        }
    }, [addMultipleShops, navigate]);

    const handleCategorySelect = useCallback((categoryItem) => {
        if (categoryItem && categoryItem.id) {
            setSelectedCategories(categoryItem.name);
            setSelectCategories_id(categoryItem.id);
        }
    }, []);

    const handlePrioritySelect = useCallback((priorityItem) => {
        if (priorityItem && priorityItem.id) {
            setSelectedPriorities(priorityItem.name);
            setSelectedPriority_id(priorityItem.id);
        }
    }, []);

    const handlePeriodSelect = useCallback((periodItem) => {
        if (periodItem) {
            setSelectedPeriodDays(periodItem.name);
            setSelectedPeriodDays_id(periodItem.value);
        }
    }, []);

    const clearSelectedShops = useCallback(() => {
        setSelectedShops([]);
        setSelectedShop_id([]);
    }, []);

    useEffect(() => {
        FetchElements(`${PLANNOGRAMM}/api/v1/priorities`, "GET", setPriorities, navigate, 2, () => navigate("/"), handleOpenAlert);
    }, [navigate]);

    useEffect(() => {
        FetchElements(`${PLANNOGRAMM}/api/v1/kusts`, "GET", setKust, navigate, 2, () => navigate("/"), handleOpenAlert);
    }, [navigate]);

    useEffect(() => {
        FetchElements(`${PLANNOGRAMM}/api/v1/categories`, "GET", setCategories, navigate, 2, () => navigate("/"), handleOpenAlert);
    }, [navigate]);

    useEffect(() => {
        if (prevDataRef.current !== selectCategories_id) {
            FetchElements(`${PLANNOGRAMM}/api/v1/formats?category_id=${selectCategories_id}`, "GET", setFormats, navigate, 2, () => navigate("/"), handleOpenAlert);
        }
        prevDataRef.current = selectCategories_id;
    }, [selectCategories_id, navigate]);

    useEffect(() => {
        FetchElements(`${PLANNOGRAMM}/api/v1/shops?task=false`, "GET", setShops, navigate, 2, () => navigate("/"), handleOpenAlert);
    }, [navigate]);

    useEffect(() => {
        if (dataTasck && dataTasck.attachments && dataTasck.attachments.length > 0) {
            initializeExistingFiles(dataTasck.attachments);
            setUploadedPhotoIds(dataTasck.attachments);
        } else {
            setUploadedPhotoIds([]);
        }
    }, [dataTasck, initializeExistingFiles]);

    useEffect(() => {
        if (dataTasck) {
            setRadioButton(dataTasck.for_close_need_photo);
            if (dataTasck.period_days) {
                const period = periodDays.find(p => p.value === dataTasck.period_days);
                if (period) {
                    setSelectedPeriodDays(period.name);
                }
            }
        }
    }, [dataTasck]);

    useEffect(() => {
        if (dataTasck?.shops) {
            const ids = dataTasck.shops.map(shop => shop.id);
            setSelectedShop_id(ids);
            const names = dataTasck.shops.map(shop => shop.name);
            setSelectedShops(names);
        }
    }, [dataTasck]);

    async function addTasckPlannogramm() {
        if (hasPendingUploads) {
            handleOpenAlert("Ошибка", "Загрузка файлов еще не завершена. Пожалуйста, дождитесь окончания.", "");
            return;
        }

        if (selectedShop_id.length === 0) {
            handleOpenAlert("Ошибка", "Выберите магазин", "");
            return;
        }

        if (!selectedPriority_id) {
            handleOpenAlert("Ошибка", "Выберите приоритет", "");
            return;
        }

        await updateRefreshToken(setAccessToken, null);
        let objToSend = {
            name: selectedName,
            priority_id: selectedPriority_id,
            about: selectedDescription,
            shops_id: selectedShop_id,
            datetime_begin: selectedDateStart,
            datetime_end: selectedDataEnd,
            for_close_nead_photo: radioButton,
            attachments: uploadedPhotoIds,
            comment: selectedComment,
            period_days: selectedPeriodDays_id,
        };

        let data = JSON.stringify(objToSend);

        try {
            const response = await fetch(`${PLANNOGRAMM}/api/v1/tasks`, {
                method: "POST",
                headers: {
                    "accept": "application/json",
                    "Content-Type": "application/json",
                    "access-token": `${accessToken}`,
                },
                body: data,
            });
            if (!response.ok) {
                let data = await response.json();
                throw new Error(`${data.message}, код: ${response.status}`);
            }
            let result = await response.json();
            handleOpenAlert('Уведомление', `${result.message}`, `${response.status}`);
            navigate(-1);
        } catch (error) {
            handleOpenAlert('Ошибка', `${error.message || "Ошибка при создании задачи"}`);
        }
    }

    const handleRadioChange = () => {
        setRadioButton(!radioButton);
    };

    function formatDateForInput(dateString) {
        if (!dateString) {
            return ""
        } else {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
    }

    async function editTasckPlannogramm() {
        if (hasPendingUploads) {
            handleOpenAlert("Ошибка", "Загрузка файлов еще не завершена. Пожалуйста, дождитесь окончания.", "");
            return;
        }

        if (selectedShop_id.length === 0) {
            handleOpenAlert("Ошибка", "Выберите магазин", "");
            return;
        }

        await updateRefreshToken(setAccessToken, null);

        let objToSend = {
            name: selectedName,
            priority_id: selectedPriority_id,
            about: selectedDescription,
            shops_id: selectedShop_id,
            datetime_begin: selectedDateStart,
            datetime_end: selectedDataEnd,
            for_close_nead_photo: radioButton,
            attachments: uploadedPhotoIds,
            comment: selectedComment,
            period_days: selectedPeriodDays_id,
        };

        let data = JSON.stringify(objToSend);

        try {
            const response = await fetch(`${PLANNOGRAMM}/api/v1/tasks/${dataTasck.task_guid}`, {
                method: "PATCH",
                headers: {
                    "accept": "application/json",
                    "Content-Type": "application/json",
                    "access-token": `${accessToken}`,
                },
                body: data,
            });
            if (!response.ok) {
                let data = await response.json();
                throw new Error(`${data.message}, код: ${response.status}`);
            }
            let result = await response.json();
            handleOpenAlert('Уведомление', `${result.message}`, `${response.status || ""}`);
            navigate(-1);
        } catch (error) {
            handleOpenAlert('Ошибка', `${error.message || "Ошибка при изменении задачи"}`);
        }
    }

    function getBut(data) {
        const buttonText = !data ? "Добавить задачу" : "Изменить задачу";
        const onClick = !data ? () => addTasckPlannogramm(isLoading) : () => editTasckPlannogramm(isLoading);

        return (
            <ButtonHint
                className="plannogramm_addTasck_buttonHint"
                text={buttonText}
                funck={onClick}
            />
        );
    }

    const handleFileChange = e => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            addFiles(files);
        }
    };

    const handleDelete = (id) => {
        const photo = uploadedPhotos.find(p => p.id === id);
        if (!photo) return;
        if (photo.status === 'completed' && photo.serverId) {
            setUploadedPhotoIds(prev => prev.filter(pid => pid !== photo.serverId));
        }
        deletePhoto(id);
    };

    return (
        <div>
            {onClose ? <ButtonBack funck={onClose} /> : <ButtonBack />}
            <CustomAlert
                title={alertTitle}
                message={alertMessage}
                statusCod={alertStatusCod}
                isOpenAlert={isOpenAlert}
                onClose={handleCloseAlert}
            />
            <form className="modificatorAddWrapperPlannogramm max--width--control" id="plannogrammWrapperAddTasck">
                <div className="plannogramm_addTasck_name_and_priority">
                    <div className="plannogramm_title_wrappers">
                        <span className="plannogramm_addTasck_title">Название:</span>
                        <input className="plannogramm_addTasck_title_name"
                               placeholder={"Название задачи..."}
                               type={"text"}
                               value={selectedName}
                               onChange={(e) => setSelectedName(e.target.value)}
                        />
                    </div>
                    <div className="plannogramm_title_wrappers">
                        <span className="plannogramm_addTasck_title">Приоритет:</span>
                        <CustomSearch4
                            data={priorities}
                            name="Приоритет"
                            placeholder="Выберите приоритет..."
                            onSelect={handlePrioritySelect}
                            className="priority-select"
                            initialValue={selectedPriorities}
                            allowClear={true}
                            searchable={false}
                        />
                    </div>
                </div>
                <div className="plannogramm_addTasck_task_description">
                    <span className="plannogramm_addTasck_title">Описание:</span>
                    <textarea placeholder={"Добавьте описание..."}
                              style={{ margin: 0 }}
                              onChange={(e) => setSelectedDescription(e.target.value)}
                              className="plannogramm_addTasck_discription"
                              value={selectedDescription}
                    />
                </div>
                <div className="plannogramm_addTasck_shops_format">
                    <span className="plannogramm_addTasck_title">Периодичность создания планограмм:</span>
                    <div className="format_shops_wrapper">
                        <CustomSearch4
                            data={periodDays}
                            name="Частота создания"
                            placeholder="Укажите частоту создания планограмм..."
                            onSelect={handlePeriodSelect}
                            className="period-select"
                            initialValue={selectedPeriodDays}
                            allowClear={true}
                            searchable={false}
                        />
                    </div>
                </div>
                <div className="plannogramm_addTasck_shops_format">
                    <span className="plannogramm_addTasck_title">Выберите магазины:</span>
                    <div className="format_shops_wrapper" id={"select_group"}>
                        <CustomSearch4
                            data={categories}
                            name="Категория"
                            placeholder="Выберите категорию..."
                            onSelect={handleCategorySelect}
                            className="category-select"
                            initialValue={selectedCategories}
                            allowClear={true}
                            searchable={false}
                        />
                        <CustomSearch4
                            data={formats}
                            name="Формат"
                            placeholder="Выберите форматы..."
                            onSelect={handleFormatSelect}
                            className="format-select"
                            initialValue={selectedFormats}
                            allowClear={true}
                            searchable={false}
                        />
                        <CustomSearch4
                            data={kust}
                            name="Куст"
                            placeholder="Выберите куст..."
                            onSelect={handleKustSelect}
                            className="kust-select"
                            initialValue={selectedKust}
                            allowClear={true}
                            searchable={false}
                        />
                        <CustomSearch4
                            data={shops}
                            name="Магазин"
                            placeholder="Выберите магазин..."
                            onSelect={handleShopSelect}
                            className="shop-select"
                            allowClear={false}
                            searchable={true}
                        />
                    </div>
                    <div className="plannogramm_addTasck_selected_shop">
                        {Array.isArray(selectedShops) && selectedShops.map((item, index) => {
                            const shopId = selectedShop_id[index];
                            return (
                                <div className="plannogramm_addTasck_selected_shop_item" key={`${shopId}-${index}`}>
                                    <div className="plannogramm_addTasck_selected_shop_item_nameShops">
                                        {item}
                                    </div>
                                    <div className="plannogramm_addTasck_selected_shop_item_remowItem"
                                         onClick={() => removeShop(index)}>
                                        ×
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="butClearSelectedShops" onClick={clearSelectedShops}>
                        <HandySvg src={trashSVG} className="trashIcon" />
                        Очистить выбранные магазины
                    </div>
                </div>
                <div className="plannogramm_addTasck_dataTime">
                    <div className="plannogramm_addTasck_start_dataTime">
                        <span className="plannogramm_addTasck_title">Дата исполнения:</span>
                        <div className="plannogramm_addTasck_dataTime_underWrapper">
                            <div className="data_start">
                                <span className="plannogramm_addTasck_title">C:</span>
                                <input
                                    type={"date"}
                                    className="plannogramm_inputDate"
                                    value={selectedDateStart}
                                    onChange={(e) => setSelectedDateStart(e.target.value)}
                                />
                            </div>
                            <div className="data_end">
                                <span className="plannogramm_addTasck_title">По:</span>
                                <input
                                    type={"date"}
                                    className="plannogramm_inputDate"
                                    value={selectedDataEnd}
                                    onChange={(e) => setSelectedDataEnd(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <label className="plannogramm_addTasck_radio_button">
                        <input
                            className="plannogramm_addTasck_radio_radio_input"
                            type="checkbox"
                            name="photoRadio"
                            checked={radioButton}
                        />
                        <div
                            className="stlradio"
                            onClick={(event) => {
                                handleRadioChange();
                            }}
                        />
                        Для закрытия задачи нужен фотоотчет
                    </label>
                </div>
                <div>
                    <span className="plannogramm_addTasck_title">Пример выполнения задачи:</span>
                    <div>
                        <div className={`hint__container--photoGallery`} id="photoGallery">
                            <div className={`wrapper__file-upload`}>
                                <div className="file-upload">
                                    <img src={AddPhotoSVG} alt="upload" loading="lazy" />
                                    <h3 className="file-upload-text">Добавьте фото...</h3>
                                    <input
                                        type="file"
                                        multiple={true}
                                        accept="image/png, image/jpg, image/jpeg, image/webp"
                                        onChange={handleFileChange}
                                        capture={'environment'}
                                    />
                                </div>
                            </div>
                            {uploadedPhotos.map(photo => {
                                const status = statuses[photo.id] || 'pending';
                                const currentProgress = progress[photo.id] || 0;
                                const previewUrl = photo.previewUrl || `${MEDIA}/api/attachments/${photo.serverId}`;

                                return (
                                    <div className="img_wrapper" key={photo.id} id={photo.id}>
                                        <HandySvg
                                            src={closeSVG}
                                            className="close_img"
                                            onClick={() => handleDelete(photo.id)}
                                        />
                                        <div
                                            className={`wrapper__file-upload addImg ${status === 'pending' ? "AwaitingDownload" : ""}`}
                                            style={{
                                                backgroundImage: `url(${previewUrl})`,
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "cover",
                                                padding: "0",
                                            }}
                                        >
                                            {status === 'pending' && (
                                                <div className="wrapper__file-upload__diteils">
                                                    <div>Ожидает</div>
                                                </div>
                                            )}

                                            {status === 'uploading' && (
                                                <div className="wrapper__file-upload__diteils">
                                                    <div>Загрузка {currentProgress}%</div>
                                                </div>
                                            )}

                                            {status === 'error' && (
                                                <div className="wrapper__file-upload__diteils LongLoadingTime">
                                                    <div>Ошибка</div>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            retryUpload(photo.id);
                                                        }}
                                                        className="retry-button"
                                                    >
                                                        Повторить
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="plannogramm_addTasck_comment">
                    <span className="plannogramm_addTasck_title">Комментарий:</span>
                    <textarea
                        placeholder="Комментарий к задачи..."
                        className="textarea_commenst"
                        value={selectedComment}
                        rows={4}
                        onChange={(e) => setSelectedComment(e.target.value)}
                    />
                </div>
                {getBut(dataTasck)}
            </form>
        </div>
    );
};
export default PlannogrammAddTasck;